<div class="map" leaflet [leafletOptions]="options"></div>